import {Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse} from '@angular/common/http';
import {Observable, catchError, throwError} from 'rxjs';
import {PORTAL_CODE} from 'src/app/app.constants';

@Injectable()

export class PortalCodeInterceptor implements HttpInterceptor {
  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    request = request.clone({
      setHeaders: {
        'X-Portal-Code': PORTAL_CODE
      }
    });
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 403 && error.error?.Error === 'PortalRestricted') {
          const restrictionType = error.error.RestrictionType;
          const message = restrictionType === 'Renewal'
            ? 'This plan is not currently available for online renewal.'
            : 'This plan is not currently available for online purchase.';
          console.error(`[PortalRestriction] ${message}`, {portalCode: PORTAL_CODE, url: request.url});
        }
        return throwError(() => error);
      })
    );
  }
}
